import { Users, FileText, BarChart2, X, Trash, Search } from 'react-feather';
import { ReactComponent as Roles } from '../../assets/images/icons/roles_active.svg';
import { ReactComponent as Finger } from '../../assets/images/icons/ico_fichas.svg';
import { ReactComponent as Constancias } from '../../assets/images/icons/ico_constancias.svg';

export default [
	{
		id: 'users',
		title: 'Usuarios',
		icon: <Users style={{ width: '18px' }} />,
		navLink: '/users',
		resource: 'usuarios',
		action: 'show'
	},
	{
		id: 'rolesPermissions',
		title: 'Roles y Permisos',
		icon: <Roles style={{ height: '20px' }} />,
		navLink: '/roles',
		resource: 'roles',
		action: 'show'
	},
	{
		id: 'fichasActivas',
		title: 'Fichas Activas',
		icon: <Finger size={20} />,
		navLink: '/fichas_activas',
		resource: 'fichas_activas',
		action: 'show'
	},
	{
		id: 'fichasCanceladas',
		title: 'Fichas Canceladas',
		icon: <X size={20} />,
		navLink: '/fichas_canceladas',
		resource: 'fichas_canceladas',
		action: 'show'
	},
	{
		id: 'fichasEliminadas',
		title: 'Fichas Eliminadas',
		icon: <Trash style={{ width: '18px' }} />,
		navLink: '/fichas_eliminadas',
		resource: 'fichas_eliminadas',
		action: 'show'
	},
	{
		id: 'consultaFichas',
		title: 'Consulta de Fichas',
		icon: <Search style={{ width: '18px' }} />,
		navLink: '/consulta_fichas',
		resource: 'consultar_fichas',
		action: 'show'
	},
	{
		id: 'consultaFamiliar',
		title: 'Consulta Familiar',
		icon: <Search style={{ width: '18px' }} />,
		navLink: '/consulta_familiar',
		resource: 'roles',
		action: 'show'
	},
	{
		id: 'listadoCatalogos',
		title: 'Catálogos',
		icon: <Finger size={20} />,
		navLink: '/catalogos',
		resource: 'catalogos',
		action: 'show'
	},
	{
		id: 'listadoConstancias',
		title: 'Constancias',
		icon: <Constancias size={20} />,
		navLink: '/constancias',
		resource: ['constancias', 'en_linea'],
		action: 'show',
		someRole: true
	},
	{
		id: 'registers',
		title: 'Registros',
		icon: <FileText size={20} />,
		navLink: '/registers',
		resource: 'registros',
		action: 'show'
	},
	{
		id: 'modulos',
		title: 'Modulos',
		icon: <Search style={{ width: '18px' }} />,
		navLink: '/modulos',
		resource: 'modulos',
		action: 'show'
	},
	{
		id: 'reportesParent',
		title: 'Reportes',
		icon: <BarChart2 size={20} />,
		navLink: '/reportes',
		resource: 'reportes',
		action: 'show',
		children: [
			{
				id: 'reportes_bitacora_fichas',
				title: 'Bitácora consulta fichas',
				navLink: '/reportes/bitacora_fichas',
				resource: 'reportes',
				action: 'show'
			},
			{
				id: 'reportes_bitacoras_consultas',
				title: 'Bitácora consultas constancias',
				navLink: '/reportes/bitacoras_consultas',
				resource: 'reportes',
				action: 'show'
			},
			{
				id: 'reportes_constancias_expedidas',
				title: 'Constancias expedidas',
				navLink: '/reportes/constancias_expedidas',
				resource: 'reportes',
				action: 'show'
			},
			{
				id: 'reportes_estadisticas_constancias',
				title: 'Estadisticas constancias',
				navLink: '/reportes/estadisticas_constancias',
				resource: 'reportes',
				action: 'show'
			},
			{
				id: 'reportes_solicitudes_constancias',
				title: 'Solicitudes constancias',
				navLink: '/reportes/solicitudes_constancias',
				resource: 'reportes',
				action: 'show'
			},
			{
				id: 'reportes_fichas',
				title: 'Fichas',
				navLink: '/reportes/fichas',
				resource: 'reportes',
				action: 'show'
			}
		]
	}
];
